import { IntegrationMonitoringTranslations } from '../models/integration-monitoring-translaction-model';

// eslint-disable-next-line import/prefer-default-export
export const enUS: IntegrationMonitoringTranslations = {
  title: 'Integration Monitoring',
  filter: {
    expandSearch: 'Expand search',
    collapseSearch: 'Collapse search',
    clear: 'Clear filters',
    search: 'Search',
    integrationType: 'Integration type',
    processType: 'Process type',
    financialGroup: 'Financial group',
    carrier: 'Carrier',
    contract: 'Contract',
    receivedPeriod: 'Received period',
    status: 'Status',
    placeholders: {
      select: 'Select',
      period: 'Select period',
    },
    integrationTypes: {
      api: 'API',
      rpa: 'RPA',
    },
    processTypes: {
      coparticipation: 'Coparticipation',
      carrierCadastralMovement: 'Carrier cadastral movement',
      clientCadastralMovement: 'Client cadastral movement',
      payroll: 'Payroll',
    },
    requestStatus: {
      RECEIVED: 'Received',
      PROCESSING: 'Processing',
      COMPLETED: 'Completed',
      COMPLETED_WITH_ERRORS: 'Completed with errors',
      PROCESSED: 'Processed',
      PARTIALLY_PROCESSED: 'Partially Processed',
      ERROR: 'Error',
    },
  },
  indicators: {
    totalRequests: 'Total requests',
    totalWithErrors: 'Requests with errors',
    periodDays: 'Last {n} days',
    periodDay: 'Last day',
  },
  table: {
    headers: {
      carrier: 'Carrier',
      financialGroup: 'Financial Group',
      contract: 'Contract',
      competence: 'Competence',
      status: 'Status',
      receivedAt: 'Received date/time',
      actions: 'Actions',
    },
    loading: 'Loading requests...',
    noData: 'No requests found for the selected filters.',
    noResult: 'No results found.',
    batchErrorItems: 'Batch completed with {n} item(s) in error.',
  },
  messages: {
    searchError: 'Error fetching integration monitoring data.',
    requiredFilters: 'Provide the period and at least one of: carrier, financial group or contract.',
    exportSuccess: 'JSON download started successfully.',
    exportError: 'Error exporting the request as JSON.',
    forbiddenAccess: 'No permission for internal monitoring.',
    noPermission: 'You do not have permission to access Integration Monitoring.',
  },
  actions: { exportJson: 'Export received requests (JSON)' },
};
